module.exports = __webpack_public_path__ + "img/air-icon.064b2d25.png";